import { UniformLayout } from '../../types/layout';

const horizontalStack: (
  memberCount: number,
  containingHeight: number,
  containingWidth: number,
  padding?: number,
) => UniformLayout = (memberCount, height, width, padding = 0) => {
  const memberHeight = height;
  const memberWidth = width / memberCount;
  const unpaddedWidth = memberWidth - padding * 2;

  const layout = (index: number) => {
    return {
      height: memberHeight,
      width: unpaddedWidth,
      y: 0,
      x: padding + index * memberWidth,
    };
  };

  Object.assign(layout, {
    height,
    width,
    memberHeight,
    memberWidth,
  });

  return layout as UniformLayout;
};

export default horizontalStack;
